export var itemsExport=[
    {
        "title":"Exportar",
        "label": "...",
        "menu": [
            {
                "type": "jpg", "label": "IMAGEN" , "options": { "addURL":false }   
              }
        ]
    }
];